import { PlanType } from 'chaika-enums';

const PLAN_TYPES_AVAILABLE_FOR_ANY_ORGANIZATION = new Set<PlanType>([
    PlanType.Doctor,
    PlanType.DoctorSubscription,
    PlanType.Patient,
]);

interface PlanAvailabilityFields {
    type: PlanType;
    contractId?: string;
}

export function isPlanAvailableInOrganization(
    { type, contractId }: PlanAvailabilityFields,
    activeContractIds: Set<string>,
): boolean {
    return !contractId || PLAN_TYPES_AVAILABLE_FOR_ANY_ORGANIZATION.has(type) || activeContractIds.has(contractId);
}
